<template>
	<div id="cortesias" class="tab-content">
		<clip-loader class="dashboard-tab-loader" :loading="isCargandoEvento" :color="'var(--color-blue-link)'" :size="'52px'"></clip-loader>
		<div class="cortesias-main" v-if="!isCargandoEvento">
			<div class="filtros">
				<div class="filtro-group">
					<label for="fId">Cortesía Id</label>
					<input type="text" v-model="filtros.id" @keypress="soloNumeros" name="fId" id="fId" v-on:keyup.enter="getCortesias()" />
				</div>
				<div class="filtro-group">
					<label for="fTipo">Tipo</label>
					<select name="fTipo" id="fTipo" v-model="filtros.tipo" @change="getCortesias()">
						<option v-for="cortesiaTipo in CortesiasTipo" :key="cortesiaTipo.CortesiaTipoId" :value="cortesiaTipo.CortesiaTipoId">{{ cortesiaTipo.CortesiaTipoNombre }}</option>
					</select>
				</div>
				<div class="filtro-group">
					<label for="fSolicitante">Nombre del solicitante</label>
					<input type="text" v-model="filtros.solicitante" name="fSolicitante" id="fSolicitante" v-on:keyup.enter="getCortesias()" />
				</div>
				<div class="filtro-group">
					<label for="fUsuario">Usuario emisor</label>
					<input type="text" v-model="filtros.email" name="fUsuario" id="fUsuario" v-on:keyup.enter="getCortesias()" />
				</div>
				<div class="filtro-group">
					<label for="fTribuna">Tribuna</label>
					<select name="fTribuna" id="fTribuna" v-model="filtros.tribuna" @change="tribunaChanged()">
						<option value="0">(Todas)</option>
						<option :value="tribuna.TribunaId" v-for="tribuna in filtros.ColTribunas" :key="tribuna.TribunaId">{{ tribuna.TribunaNombre }}</option>
					</select>
				</div>
				<div class="filtro-group">
					<label for="fSector">Sector</label>
					<select name="fSector" id="fSector" v-model="filtros.sector">
						<option value="">(Todos)</option>
						<option :value="sector.SectorCod" v-for="sector in filtros.ColSectores" :key="sector.SectorCod">{{ sector.SectorDescripcion }}</option>
					</select>
				</div>
				<button :disabled="isCargandoEvento" @click.prevent="getCortesias()">Buscar</button>
				<button :disabled="isCargandoEvento" @click.prevent="$modal.show('promptCrearCortesia')" v-if="orAc.Permisos.includes('CrearCortesias')"><i class='bx bx-plus'></i>Crear cortesía</button>
			</div>
			<div class="tb">
				<div class="tb-header">
					<div style="width: 90px; justify-content: center;" class="tb-header-th">Cortesia</div>
					<div style="width: calc(12% - 10px);" class="tb-header-th">Solicitante</div>
					<div style="width: calc(21% - 60px);" class="tb-header-th">Solicitante Email</div>
					<div style="width: calc(21% - 60px);" class="tb-header-th">Usuario Email</div>
					<div style="width: calc(12% - 10px);" class="tb-header-th">Fecha de ingreso</div>
					<div style="width: calc(8% - 10px);" class="tb-header-th">Tipo</div>
					<div style="width: calc(13% - 35px);" class="tb-header-th">Tribuna</div>
					<div style="width: calc(13% - 35px);" class="tb-header-th">Sector</div>
					<div style="width: 80px; justify-content: center;" class="tb-header-th">Tickets <i class='bx bxs-info-circle tb-header-th-info' content="Emitidos / Solicitados" v-tippy="{ placement : 'left', arrow: true}" ></i></div>
					<div style="width: 50px; justify-content: center;" class="tb-header-th">Link</div>
				</div>
				<div class="tb-body" v-if="!isCargandoEvento && Cortesias.length > 0">
					<div class="tb-body-row" v-for="cortesia in Cortesias" :key="cortesia.CortesiaId" @click.stop="verCortesia(cortesia.CortesiaId)" style="cursor: pointer;">
						<div style="width: 90px; text-align: center;" class="tb-body-td">{{ cortesia.CortesiaId }}</div>
						<div style="width: calc(12% - 10px);" class="tb-body-td">{{ cortesia.CortesiaSolicitanteNombre }}</div>
						<div style="width: calc(21% - 60px);" class="tb-body-td">{{ cortesia.CortesiaSolicitanteEmail }}</div>
						<div style="width: calc(21% - 60px);" class="tb-body-td">{{ cortesia.CortesiaUsuarioEmail }}</div>
						<div style="width: calc(12% - 10px);" class="tb-body-td">{{ cortesia.CortesiaFchIngTxt }}</div>
						<div style="width: calc(8% - 10px)" class="tb-body-td">{{ cortesia.CortesiaTipoNombre }}</div>
						<div style="width: calc(13% - 35px);" class="tb-body-td">{{ cortesia.CortesiaTribunaNombre }}</div>
						<div style="width: calc(13% - 35px);" class="tb-body-td">{{ cortesia.CortesiaSectorDescripcion }}</div>
						<div style="width: 80px; text-align: center;" class="tb-body-td">{{ cortesia.CantidadEmitidas }} / {{ cortesia.CantidadTotal }}</div>
						<div style="width: 50px; text-align: center;" class="tb-body-td tb-body-td-link"><a :href="cortesia.CortesiaLink" target="_blank"><i class='bx bx-link'></i></a></div>
					</div>
				</div>
				<div class="tb-body" v-else>
				<clip-loader class="dashboard-tab-loader" :loading="isCargandoEvento" v-if="isCargandoEvento" :color="'var(--color-blue-link)'" :size="'52px'"></clip-loader>
					<div class="no-results" v-else>
						No se encontraron cortesias con esos filtros
					</div>
				</div>
			</div>
			<Pagination
				:page="Pagina"
				:maxPaginas="CantPaginas"
				:loading="isCargandoEvento"
				@prevPage="prevPage()"
				@nextPage="nextPage()"
				@firstPage="firstPage()"
				@lastPage="lastPage()"
			></Pagination>
		</div>
		<modal name="promptVerCortesia" class="promptVerCortesia" transition="scale" :clickToClose="true" @closed="promptVerCortesiaClosed()">
			<div class="ver-ticket-close" @click="$modal.hide('promptVerCortesia')">
				<i class='bx bx-x'></i>
			</div>
			<div class="ver-ticket-content"  v-if="!isCargandoCortesia && Cortesia">
				<div class="ticket-header">
					<span class="title">Cortesia #{{ Cortesia.CortesiaId }}</span>
				</div>
				<div class="ticket-main">
					<span class="group-title">Datos de la cortesia</span>
					<div class="ticket-row">
						<div class="ticket-group">
							<span class="label">Tipo</span>
							<span class="value">{{ Cortesia.CortesiaTipoNombre }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Token</span>
							<span class="value">{{ Cortesia.CortesiaToken.slice(0, 12)}}... <i class='bx bx-copy' content="Copiar token" v-tippy="{ placement : 'left', arrow: true}" @click="copiar(Cortesia.CortesiaToken)"></i></span>
						</div>
						<div class="ticket-group">
							<span class="label">Usuario</span>
							<span class="value">{{ Cortesia.CortesiaUsuarioEmail }}</span>
						</div>
					</div>
					<span class="group-title">Solicitante</span>
					<div class="ticket-row ticket-row-2">
						<div class="ticket-group">
							<span class="label">Nombre</span>
							<span class="value">{{ Cortesia.CortesiaSolicitanteNombre }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Mail</span>
							<span class="value">{{ Cortesia.CortesiaSolicitanteEmail}}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Cantidad Solicitadas</span>
							<span class="value">{{ Cortesia.CantidadTotal}}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Cantidad Ingresados</span>
							<span class="value">{{ Cortesia.CantidadEmitidas }}</span>
						</div>
					</div>
					<span class="group-title">Ubicación</span>
					<div class="ticket-row ticket-row-2">
						<div class="ticket-group">
							<span class="label">Tribuna</span>
							<span class="value">{{ Cortesia.CortesiaTribunaNombre }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Sector</span>
							<span class="value">{{ Cortesia.CortesiaSectorDescripcion }}</span>
						</div>
					</div>
					<span class="group-title">Tickets</span>
					<div class="tb">
						<div class="tb-header">
							<div style="width: 22%;" class="tb-header-th">Transacción</div>
							<div style="width: 15%;" class="tb-header-th">Ticket</div>
							<div style="width: 20%;" class="tb-header-th">Espectador</div>
							<div style="width: 20%;" class="tb-header-th">Documento</div>
							<div style="width: 15%;" class="tb-header-th">Tribuna</div>
							<div style="width: 15%;" class="tb-header-th">Sector</div>
							<div style="width: 15%;" class="tb-header-th">Fecha</div>
						</div>
						<div class="tb-body" v-if="!isCargandoCortesia && Cortesia.Tickets.length > 0">
							<div class="tb-body-row tb-body-row-ticket" v-for="cortesiaticket in Cortesia.Tickets" :key="cortesiaticket.TicketId">
								<div style="width: 22%;" class="tb-body-td">{{ cortesiaticket.TransaccionId }}</div>
								<div style="width: 15%;" class="tb-body-td">{{ cortesiaticket.TicketId }}</div>
								<div style="width: 20%; font-weight: 600;" class="tb-body-td">{{ cortesiaticket.Espectador }}</div>
								<div style="width: 20%;" class="tb-body-td">{{ cortesiaticket.Documento }}</div>
								<div style="width: 15%;" class="tb-body-td">{{ cortesiaticket.Tribuna }}</div>
								<div style="width: 15%;" class="tb-body-td">{{ cortesiaticket.Sector }}</div>
								<div style="width: 15%;" class="tb-body-td">{{ cortesiaticket.TransaccionFecha }}</div>
							</div>
						</div>
						<div class="tb-body" v-else>
							<clip-loader class="dashboard-tab-loader" :loading="isCargandoEvento" v-if="isCargandoEvento" :color="'var(--color-blue-link)'" :size="'52px'"></clip-loader>
							<div class="no-results" v-else>
								No se encontraron tickets con esos filtros
							</div>
						</div>
					</div>
					<div class="ticket-row ticket-row-1">
						<button v-if="!isCargandoReEnvio && orAc.Permisos.includes('EnviarCortesiaPorCorreo')" @click.prevent="reEnviarCortesia(Cortesia)">Enviar por correo</button>
						<div class="ticket-row ticket-row-1" v-else>
							<clip-loader :loading="isCargandoReEnvio" v-if="isCargandoReEnvio" :color="'var(--color-blue-link)'" :size="'52px'" style="margin: 80px auto;"></clip-loader>
						</div>
					</div>
				</div>
			</div>
			<div class="ver-ticket-content" v-else>
				<clip-loader :loading="isCargandoCortesia" v-if="isCargandoCortesia" :color="'var(--color-blue-link)'" :size="'52px'" style="margin: 80px auto;"></clip-loader>
			</div>
		</modal>
		<modal name="promptCrearCortesia" class="promptCrearCortesia" transition="scale" :clickToClose="true" @closed="promptCrearCortesiaClosed()">
			<div class="ver-ticket-close" @click="$modal.hide('promptCrearCortesia')">
				<i class='bx bx-x'></i>
			</div>
			<div class="ver-ticket-content" v-if="!isCreandoCortesia">
				<div class="ticket-header">
					<span class="title">Crear cortesia</span>
				</div>
				<div class="ticket-main">
					<span class="group-title">Datos de la cortesia</span>
					<div class="ticket-row ticket-row-2">
						<div class="ticket-group">
							<span class="label">Tipo</span>
							<select name="STipo" id="STipo" v-model="crearOptions.tipo">
								<option v-for="cortesiaTipo in CortesiasTipo" :key="cortesiaTipo.CortesiaTipoId" :value="cortesiaTipo.CortesiaTipoId">{{ cortesiaTipo.CortesiaTipoNombre }}</option>
							</select>
						</div>
						<div class="ticket-group">
							<span class="label">Usuario</span>
							<span class="value">{{ user.UsuarioId }}</span>
						</div>
					</div>
					<span class="group-title">Solicitante</span>
					<div class="ticket-row ticket-row-2">
						<div class="ticket-group">
							<span class="label">Nombre del solicitante</span>
							<input type="text" v-model="crearOptions.solicitante" placeholder="Ej: Nombre Apellido"/>
						</div>
						<div class="ticket-group">
							<span class="label">Correo electrónico</span>
							<input type="text" v-model="crearOptions.email" placeholder="@lineuptickets.com"/>
						</div>
						<div class="ticket-group">
							<span class="label">Cantidad de tickets</span>
							<input type="text" v-model="crearOptions.cantidadTickets" @keypress="soloNumeros" @change="renderizarGrid()"/>
						</div>
					</div>
					<span class="group-title">Ubicación</span>
					<div class="ticket-row ticket-row-2">
						<div class="ticket-group">
							<span class="label">Tribuna</span>
							<select name="STribuna" id="STribuna" v-model="crearOptions.tribuna" @change="selectTribunaChanged()">
								<option value="0">(Seleccione tribuna)</option>
								<option :value="tribuna.TribunaId" v-for="tribuna in crearTribunas" :key="tribuna.TribunaId">{{ tribuna.TribunaNombre }}</option>
							</select>
						</div>
						<div class="ticket-group">
							<span class="label">Sector</span>
							<select name="SSector" id="SSector" v-model="crearOptions.sector" @change="selectSectorChanged()">
								<option value="">(Seleccione sector)</option>
								<option :value="sector" v-for="sector in crearSectores" :key="sector.SectorCod">{{ sector.SectorDescripcion }}</option>
							</select>
						</div>
					</div>
 					<span class="group-title" v-if="crearOptions.sector.SectorVentaTipo === 'N' && crearOptions.filasAsientosElegidos.length !== 0">Tickets</span>
 					<div class="tb" v-if="crearOptions.sector.SectorVentaTipo === 'N' && crearOptions.filasAsientosElegidos.length !== 0" >
						<div class="tb-header">
							<div style="width: 50%;" class="tb-header-th">Fila</div>
							<div style="width: 50%;" class="tb-header-th">Asiento</div>
						</div>
						<div class="tb-body" v-if="!isCargandoGrid">
							<div class="tb-body-row" v-for="(numero,index) in range(1,crearOptions.cantidadTickets)" :key="numero">
								<div style="width: 50%;" class="tb-body-td">
									<select name="SFila" id="SFila" v-model="crearOptions.filasAsientosElegidos[index].FilaId" @change="renderizarAsientos()">
										<option :value="fila.FilaId" v-for="fila in crearOptions.filasAsientosDisponibles" :key="fila.FilaId">{{ fila.FilaNombre }}</option>
									</select>
								</div>
								<div style="width: 50%;" class="tb-body-td" v-if="!isCargandoAsientos">
									<select name="SAsiento" id="SAsiento" v-model="crearOptions.filasAsientosElegidos[index].AsientoId">
										<option :value="asiento.AsientoId" v-for="asiento in asientosOptions(index)" :key="asiento.AsientoId">{{ asiento.AsientoNombre }}</option>
									</select>
								</div>
							</div>
						</div>
					</div> 
					<div class="ticket-row ticket-row-1">
						<button v-if="!isCreandoCortesia" @click.prevent="crearCortesia(crearOptions)">Crear</button>
						<div class="ticket-row ticket-row-1" v-else>
							<clip-loader :loading="isCreandoCortesia" v-if="isCreandoCortesia" :color="'var(--color-blue-link)'" :size="'52px'" style="margin: 80px auto;"></clip-loader>
						</div>
					</div>
				</div>
			</div>
			<div class="ver-ticket-content" v-else>
				<clip-loader :loading="isCreandoCortesia" v-if="isCreandoCortesia" :color="'var(--color-blue-link)'" :size="'52px'" style="margin: 80px auto;"></clip-loader>
			</div>
		</modal>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapState, mapActions, mapGetters }  from 'vuex';
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
	import Pagination from "../../components/Pagination.vue";

	export default {
		data(){
			return{
				isCargandoEvento: true,
				Cortesias: [],
				CortesiasTipo:[],
				EventoId: Number(this.$route.params.eventoId),

				// Paginación
				Pagina: 1,
				CantPaginas: 3,
				reinicioPaginacion: false,

				filtros: {
					id: 0,
					email: '',
					solicitante: '',
					tipo:0,
					tribuna: 0,
					sector: '',

					ColTribunas: [],
					ColSectores: [],
				},

				Cortesia: null,

				isCargandoCortesia:false,

				isCargandoReEnvio:false,

				isCreandoCortesia: false,

				crearTribunas: [],
				crearSectores: [],

				crearOptions:{
					tipo: 0,
					solicitante: '',
					email: '',
					cantidadTickets: 0,
					tribuna:0,
					sector: [],
					filasAsientosDisponibles: [],
					filasAsientosElegidos: []
				},

				isCargandoAsientos: false,

				SDTFilaAsientos:[],

				isCargandoGrid: false
			}
		},
		components: {
			ClipLoader,
			Pagination
		},
		computed: {
			...mapState('AuthModule', ['user', 'organizadorActivo']),
			...mapGetters('AuthModule', ['orAc']),
		},
		async mounted(){
			this.getCortesiasTipo();
			this.getTribunas();
			await this.getCortesias();
		},
		methods: {
			...mapActions('AuthModule', ['logout']),

			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			async getCortesias(){
				try {
					this.Cortesias = [];
					this.isCargandoEvento = true;

					let response = await axios.post('/WSOrgEveCortesias', {
						OrganizadorId: Number(this.organizadorActivo),
						UsuarioId: this.user.UsuarioId,
						EventoId: Number(this.EventoId),
						Pag: Number(this.Pagina),
						Limit: 20,
						FCortesiaId: this.filtros.id,
						FSolicitante: this.filtros.solicitante,
						FSolicitanteEmail: this.filtros.email,
						FCortesiaTipoId: this.filtros.tipo,
						FTribunaId: Number(this.filtros.tribuna),
						FSectorCod: this.filtros.sector,
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							this.CantPaginas = response.data.CantPaginas
							this.Cortesias = response.data.SDTDashboardEventoCortesias
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error, intente nuevamente.')
					this.$router.push({ name: 'error' })
				} finally {
					this.isCargandoEvento = false
				}
			},
			async getCortesiasTipo(){
				try {
					this.CortesiasTipo = [];

					let response = await axios.post('/WSOrgEveCortesiaTipo', {},{ headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });
					if(response.data.ErrorCod === 0){
						this.CortesiasTipo = response.data.SDTDashboardEventoCortesiasTipo
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error, intente nuevamente.')
					this.$router.push({ name: 'error' })
				} 
			},
			async getTribunas(){
				try {

					this.filtros.ColTribunas = [];
					this.crearTribunas = [];

					let response = await axios.post('/WSOrgEveTribunas', {
						EventoId: Number(this.EventoId)
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							this.filtros.ColTribunas = response.data.SDTDashboardTribunas
							this.crearTribunas = response.data.SDTDashboardTribunas
						}
					}
				} catch (error) {
				}
			},
			async getSectores(){
				try {
					this.filtros.ColSectores = [];

					let response = await axios.post('/WSOrgEveSectores', {
						EventoId: Number(this.EventoId),
						TribunaId: Number(this.filtros.tribuna)
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							this.filtros.ColSectores = response.data.SDTDashboardSectores
						}
					}
				} catch (error) {
				}
			},
			async tribunaChanged(){
				this.filtros.ColSectores = [];

				if(this.filtros.tribuna !== '0'){
					await this.getSectores();
				} else {
					this.filtros.sector = ''
				}
			},
			async getSelectSectores(){
				try {
					this.crearSectores = [];

					let response = await axios.post('/WSOrgEveSectores', {
						EventoId: Number(this.EventoId),
						TribunaId: Number(this.crearOptions.tribuna)
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							this.crearSectores = response.data.SDTDashboardSectores
						}
					}
				} catch (error) {
				}
			},
			async getSelectFilasAsientos(){
				try {
					this.crearOptions.filasAsientosDisponibles = [];

					let response = await axios.post('/WSOrgEveFilasAsientos', {
						EventoId: Number(this.EventoId),
						TribunaId: Number(this.crearOptions.tribuna),
						SectorCod: this.crearOptions.sector.SectorCod
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else{
						if(response.data.ErrorCod === 0){
							this.crearOptions.filasAsientosDisponibles = response.data.SDTDashboardFilasAsientos
						}
					}
				} catch (error) {
				}
			},
			async selectTribunaChanged(){
				this.crearSectores = []
				this.crearOptions.filasAsientosElegidos = []

				if(this.crearOptions.tribuna !== '0'){
					await this.getSelectSectores();
				}
			},
			async selectSectorChanged(){
				this.crearOptions.filasAsientosElegidos = []

				if(this.crearOptions.sector.SectorCod !== ''){
					await this.getSelectFilasAsientos();
					await this.crearArray();
				}
			},
			async verCortesia(id){
				try {
					this.isCargandoCortesia = true
					let response = await axios.post('/WSOrgEveCortesia',
						{
							OrganizadorId: Number(this.organizadorActivo),
							UsuarioId: this.user.UsuarioId,
							EventoId: this.EventoId,
							CortesiaId: id
						}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} }
					);

					if (response.data.ErrorCod === 0){
						this.Cortesia = response.data.SDTDashboardCortesia
						this.$modal.show('promptVerCortesia');
					} else{
						this.$store.dispatch('showError', 'Ocurrió un error al visualizar la cortesia.')
					}
					
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error al visualizar la cortesia.')
				} finally{
					this.isCargandoCortesia = false
				}
			},
			async promptVerCortesiaClosed(){
				this.Cortesia = null
			},
			async promptVerTicketClosed(){
			},
			async copiar(texto) {
				await this.$copyText(texto).then(
					function () {
					},
					function () {}
				);

				this.$store.dispatch('showSuccess', 'Copiado!')
			},
			async reEnviarCortesia(Cortesia){
				try{
					this.isCargandoReEnvio = true
 					let response = await axios.post('/WSOrgEveReEnviarCortesia',
						{
							OrganizadorId: Number(this.organizadorActivo),
							UsuarioId: this.user.UsuarioId,
							CortesiaEventoId: Number(Cortesia.EventoId),
							CortesiaId: Number(Cortesia.CortesiaId),
							CortesiaSolicitanteNombre: Cortesia.CortesiaSolicitanteNombre,
							CortesiaSolicitanteEmail: Cortesia.CortesiaSolicitanteEmail,
							CortesiaTipoId: Number(Cortesia.CortesiaTipoId),
							CortesiaToken: Cortesia.CortesiaToken,
							CortesiaUsuarioId: this.user.UsuarioId,
							CortesiaCntSolicitadas: Cortesia.CantidadTotal,
							CortesiaTribunaId: Number(Cortesia.CortesiaTribunaId),
							CortesiaSectorCod: Cortesia.CortesiaSectorCod,
							CortesiaEscenarioId: Number(Cortesia.CortesiaEscenarioId)
						}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} }

					);
					
					if  (response.data.ErrorCod === 0){
						this.$store.dispatch('showSuccess', 'Cortesia enviada correctamente.')
					}
				} catch(error){
					this.$store.dispatch('showError', 'Ocurrió un error al enviar la cortesia.')
				} finally{
					this.isCargandoReEnvio = false
				}
			},
			async promptCrearCortesiaClosed(){
				this.crearOptions.tipo = 0,
				this.crearOptions.solicitante = '',
				this.crearOptions.email = '',
				this.crearOptions.cantidadTickets = 0,
				this.crearOptions.tribuna = 0,
				this.crearOptions.sector = ''
			},
			async crearCortesia(NewCortesia){
 				try{
					this.isCreandoCortesia = true
					
					if(NewCortesia.sector.SectorVentaTipo === 'N'){
						for(let i = 0; i < NewCortesia.cantidadTickets; i++){
							this.SDTFilaAsientos[i] = {Fila: NewCortesia.filasAsientosElegidos[i].FilaId, Asiento: parseInt(NewCortesia.filasAsientosElegidos[i].AsientoId)}
						}
					} else {
						this.SDTFilaAsientos = []
					}

 					let response = await axios.post('/WSOrgEveAltaCortesia',
						{
							OrganizadorId: Number(this.organizadorActivo),
							UsuarioId: this.user.UsuarioId,
							EventoId:this.EventoId,
							CortesiaTipoId: NewCortesia.tipo,
							CortesiaSolicitanteNombre: NewCortesia.solicitante,
							CortesiaSolicitanteEmail: NewCortesia.email,
							CortesiaCntSolicitadas: NewCortesia.cantidadTickets,
							CortesiaTribunaId: NewCortesia.tribuna,
							CortesiaSectorCod: NewCortesia.sector.SectorCod,
							SDTFilaAsientos: this.SDTFilaAsientos
						}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} }

					);
					
					if(response.data.ErrorCod === 0){
						this.$store.dispatch('showSuccess', 'Cortesia creada correctamente.')
						this.$modal.hide('promptCrearCortesia')
						await this.getCortesias();
					} else {
						this.$store.dispatch('showError', response.data.ErrorDsc)
					}
				} catch(error){
					this.$store.dispatch('showError', 'Ocurrió un error al crear la cortesia.')
				} finally{
					this.isCreandoCortesia = false
				}
			},
			range(start, end){
				const result = [];
				for (let i = start; i <= end; i++) {
					result.push(i);
				}
				return result;
			},
			async crearArray(){
				this.crearOptions.filasAsientosElegidos = []
				for (let i = 0; i < this.crearOptions.filasAsientosDisponibles.length; i++){
					if (this.crearOptions.filasAsientosDisponibles[i].FilaId > 0){
						for (let j = 0; j < this.crearOptions.cantidadTickets; j++){
							this.crearOptions.filasAsientosElegidos[j] = {FilaId: this.crearOptions.filasAsientosDisponibles[i].FilaId, AsientoId: this.crearOptions.filasAsientosDisponibles[i].Asientos[0].AsientoId}
						}
						break
					}
				}
			},
			asientosOptions(index){
				let filaIdBuscado = this.crearOptions.filasAsientosElegidos[index].FilaId
				let indice = this.crearOptions.filasAsientosDisponibles.findIndex(objeto => objeto.FilaId == filaIdBuscado)
				let asientos = this.crearOptions.filasAsientosDisponibles[indice].Asientos
				return asientos;
			},
			renderizarAsientos(){
				this.isCargandoAsientos = true

				this.isCargandoAsientos = false
			},
			async prevPage() {
				if (this.Pagina > 1) {
					this.reinicioPaginacion = false;
					this.Pagina -= 1;
					this.getCortesias();
				}
			},
			async nextPage() {
				if (this.Pagina < this.CantPaginas) {
					this.reinicioPaginacion = false;
					this.Pagina += 1;
					this.getCortesias();
				}
			},
			async firstPage() {
				this.reinicioPaginacion = false;
				this.Pagina = 1;
				this.getCortesias();
			},
			async lastPage() {
				this.reinicioPaginacion = false;
				this.Pagina = this.CantPaginas;
				this.getCortesias();
			},
			async reiniciarPaginacion() {
				this.Pagina = 1;
				this.CantPaginas = 1;
			},
			renderizarGrid(){
				this.isCargandoAsientos = true
				
				if (this.crearOptions.cantidadTickets > this.crearOptions.filasAsientosElegidos.length){
					for (let i = 0; i < this.crearOptions.filasAsientosDisponibles.length; i++){
						if (this.crearOptions.filasAsientosDisponibles[i].FilaId > 0){
							for (let j = this.crearOptions.filasAsientosElegidos.length; j < this.crearOptions.cantidadTickets; j++){
								this.crearOptions.filasAsientosElegidos[j] = {FilaId: this.crearOptions.filasAsientosDisponibles[i].FilaId, AsientoId: this.crearOptions.filasAsientosDisponibles[i].Asientos[0].AsientoId}
							}
							break
						}
					}
				}else{
					let k = this.crearOptions.filasAsientosElegidos.length - this.crearOptions.cantidadTickets
					for (let j = 1 ; j <= k; j++){
						let index = this.crearOptions.filasAsientosElegidos.length - j
						this.crearOptions.filasAsientosElegidos.splice(index,1)
					}
				}
				
				this.isCargandoAsientos = false		
			}
		}
    };
		
</script>

<style lang="scss" scoped>
	.cortesias-main{
		width: 100%;
		@include flex(column, center, center);
		
		.filtros{
			width: 100%;
			display: grid;
			grid-template-columns: repeat(8, 1fr);
			grid-auto-rows: 1fr;
			grid-column-gap: 14px;
			grid-row-gap: 10px;
			margin: 0px;
			margin-bottom: 20px;
			align-items: end;

			.filtro-group{
				@include flex(column, center, flex-start);
				width: 100%;

				label{
					font-size: 11px;
					font-weight: var(--fw-500);
					line-height: 1em;
					margin-bottom: 4px;
				}

				input {
					-webkit-appearance: none;
					appearance: none;
					border: none;
					width: 100%;
					padding: 0px 14px;
					font-size: 12px;
					font-weight: var(--fw-400);
					line-height: 1.4em;
					width: 100%;
					border-radius: 8px;
					height: 38px;
					outline: none;
					box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;

					&::placeholder {
						color: #9aa5b5;
						opacity: 1;
					}

					&:-ms-input-placeholder {
						color: #9aa5b5;
					}

					&::-ms-input-placeholder {
						color: #9aa5b5;
					}

					&:focus-within {
						@include transition(all 0.2s);
						box-shadow: #222 0px 0px 0px 2px inset;

						&.form-input--error {
							box-shadow: var(--color-red-error) 0px 0px 0px 2px inset;
						}
					}

					&.form-input--error {
						box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
					}
				}

				select{
					@include sinApariencia();
					width: 100%;
					height: 38px;
					background-image: url('../../assets/ChevronUpDown.svg');
					background-repeat: no-repeat;
					background-size: 18px;
					background-position: right 5px center;
					background-color: transparent;
					font-size: 12px;
					font-weight: var(--fw-400);
					line-height: 1.4em;
					outline: none;
					border: none;
					box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
					padding: 0 14px;
					border-radius: 8px;
					cursor: pointer;

					&:focus{
						box-shadow: #222 0px 0px 0px 2px inset;
					}
				}
			}

			button{
				@include flex(row, center, center);
				background-color: var(--color-darker);
				border: 1px solid var(--color-darker);
				border-radius: 8px;
				outline: none;
				padding: 0px 14px;
				color: var(--color-white);
				font-size: 13px;
				font-weight: var(--fw-500);
				font-family: var(--font-sora);
				line-height: 1.4em;
				letter-spacing: 1px;
				margin: 0px;
				height: 38px;
				@include transition(all 0.2s);
				cursor: pointer;
				@include flex(row, center, center);

				i{
					margin-right: 5px;
					font-size: 18px;
				}

				&:hover {
					background-color: var(--color-primary);
					border: 1px solid var(--color-darker);
					transform: translate(-0.25rem, -0.25rem);
					box-shadow: 0.25rem 0.25rem 0 var(--color-darker);
					color: var(--color-darker);
				}

				&:disabled {
					background-color: #e8e9eb;
					color: var(--color-darker);
					border-color: #e8e9eb;
					cursor: not-allowed;

					&:hover{
						box-shadow: none;
						transform: none;
						border-color: #e8e9eb;
					}
				}
			}
		}
	}

	.no-results{
		background-color: #e8e9eb;
		width: fit-content;
		margin: 40px auto 20px auto;
		@include flex(row, center, center);
		border-radius: 8px;
		padding: 5px 10px;
		text-align: center;
		font-weight: var(--fw-300);
		font-size: 13px;
	}
</style>